import React from "react";
import { UserProvider } from "./UserContext";
import { AuthProvider } from "./AuthContext"; 
import { SearchVectorProvider } from "./SearchVectorContext";
import { UserQueryProvider } from "./UserQueryContext";
import { SearchVectorLoadingProvider } from "./SearchVectorLoadingContext";
import { SelectedCategoryProvider } from "./SelectedCategoryContext";
import { SelectedCityProvider } from "./SelectedCityContext";
import { SelectedBudgetProvider } from "./SelectedBudgetContext";
import { SignUpInfoProvider } from "./SignUpInfoContext";
import { MastheadRefProvider } from "./MastheadRefContext";

const AppContextProvider = ({ children }) => {
  return (
    <MastheadRefProvider>
      <AuthProvider>
        <SignUpInfoProvider>
          <UserProvider>
            <UserQueryProvider>
              <SelectedCategoryProvider>
                <SelectedCityProvider>
                  <SelectedBudgetProvider>
                    <SearchVectorProvider>
                      <SearchVectorLoadingProvider>
                        {children}
                      </SearchVectorLoadingProvider>
                    </SearchVectorProvider>
                  </SelectedBudgetProvider>
                </SelectedCityProvider>
              </SelectedCategoryProvider>
            </UserQueryProvider>
          </UserProvider>
        </SignUpInfoProvider>
      </AuthProvider>
    </MastheadRefProvider>
  );
};

export default AppContextProvider;
